/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Create_Account_SubInputs */

const th_admin_create_account_sub = /** @type {(inputs: Admin_Create_Account_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สำหรับผู้ที่ต้องมีบัญชีก่อนเข้าสู่ระบบ เช่น ผู้ฝึกสอนที่ทีมต้องระบุชื่อ หรืออีเมลที่ส่งไม่สำเร็จ ผู้ใช้จะเข้าสู่ระบบด้วยรหัสเช่นเดียวกับคนอื่น`)
};

const en_admin_create_account_sub = /** @type {(inputs: Admin_Create_Account_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For somebody who needs to exist before they can sign in — a coach a team must name, or an address that keeps bouncing. They sign in with a code like everybody else.`)
};

const ja_admin_create_account_sub = /** @type {(inputs: Admin_Create_Account_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サインインより先に存在している必要がある人のために — チームが指名するコーチや、メールが届かない場合など。本人は他の人と同じくコードでサインインします。`)
};

const zh_admin_create_account_sub = /** @type {(inputs: Admin_Create_Account_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`给那些必须先存在、之后才能登录的人用——比如球队需要指定的教练，或一个反复出现的邮箱地址。他们和其他人一样用验证码登录。`)
};

const es_admin_create_account_sub = /** @type {(inputs: Admin_Create_Account_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para alguien que necesita existir antes de poder iniciar sesión: un entrenador que un equipo debe nombrar, o una dirección que sigue rebotando. Inician sesión con un código, como todos los demás.`)
};

const pt_admin_create_account_sub = /** @type {(inputs: Admin_Create_Account_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para alguém que precisa existir antes de poder entrar — um técnico que um time precisa nomear, ou um endereço que fica voltando. Eles entram com um código, como todo mundo.`)
};

const id_admin_create_account_sub = /** @type {(inputs: Admin_Create_Account_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untuk orang yang harus ada sebelum bisa masuk — pelatih yang perlu ditunjuk sebuah tim, atau alamat yang terus muncul kembali. Mereka masuk dengan kode, sama seperti yang lain.`)
};

const fr_admin_create_account_sub = /** @type {(inputs: Admin_Create_Account_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pour quelqu’un qui doit exister avant de pouvoir se connecter — un entraîneur qu’une équipe doit nommer, ou une adresse qui rebondit sans cesse. Ils se connectent avec un code, comme tout le monde.`)
};

const tl_admin_create_account_sub = /** @type {(inputs: Admin_Create_Account_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para sa taong kailangang umiral bago makapag-sign in — isang coach na kailangang italaga ng isang team, o isang address na paulit-ulit na bumabalik. Mag-sign in sila gamit ang code, tulad ng lahat.`)
};

const vi_admin_create_account_sub = /** @type {(inputs: Admin_Create_Account_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dành cho người cần tồn tại trước khi đăng nhập được — một huấn luyện viên mà đội cần chỉ định, hoặc một địa chỉ cứ quay lại mãi. Họ đăng nhập bằng mã, như mọi người khác.`)
};

const ko_admin_create_account_sub = /** @type {(inputs: Admin_Create_Account_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`로그인하기 전에 먼저 존재해야 하는 사람을 위한 것입니다 — 팀이 지정해야 하는 코치나, 자꾸 다시 나타나는 주소 같은 경우입니다. 다른 사람들과 마찬가지로 코드로 로그인합니다.`)
};

const de_admin_create_account_sub = /** @type {(inputs: Admin_Create_Account_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für jemanden, der existieren muss, bevor er sich anmelden kann — einen Trainer, den ein Team benennen muss, oder eine Adresse, die immer wieder zurückkommt. Angemeldet wird sich mit einem Code, wie bei allen anderen.`)
};

const ru_admin_create_account_sub = /** @type {(inputs: Admin_Create_Account_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Для того, кто должен существовать раньше, чем сможет войти, — тренера, которого нужно назначить команде, или адреса, который всё время возвращается. Входят они по коду, как и все остальные.`)
};

const tr_admin_create_account_sub = /** @type {(inputs: Admin_Create_Account_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giriş yapabilmesi için önce var olması gereken biri için — bir takımın ataması gereken bir antrenör ya da sürekli geri gelen bir adres. Herkes gibi kodla giriş yaparlar.`)
};

const it_admin_create_account_sub = /** @type {(inputs: Admin_Create_Account_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Per chi deve esistere prima di poter accedere: un allenatore che una squadra deve nominare, o un indirizzo che continua a ricomparire. Accedono con un codice, come tutti gli altri.`)
};

const pl_admin_create_account_sub = /** @type {(inputs: Admin_Create_Account_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dla kogoś, kto musi istnieć, zanim będzie mógł się zalogować — trenera, którego drużyna musi wskazać, albo adresu, który wciąż wraca. Logują się kodem, jak wszyscy.`)
};

const uk_admin_create_account_sub = /** @type {(inputs: Admin_Create_Account_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Для того, хто має існувати раніше, ніж зможе увійти, — тренера, якого має призначити команда, або адреси, що весь час повертається. Вони входять за кодом, як і всі інші.`)
};

const hi_admin_create_account_sub = /** @type {(inputs: Admin_Create_Account_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उनके लिए जिन्हें साइन इन करने से पहले मौजूद होना चाहिए — कोई कोच जिसे टीम को नियुक्त करना है, या कोई पता जो बार-बार लौट आता है। वे भी सबकी तरह कोड से साइन इन करते हैं।`)
};

const ar_admin_create_account_sub = /** @type {(inputs: Admin_Create_Account_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لمن يجب أن يوجد قبل أن يتمكن من تسجيل الدخول — مدرب يحتاج فريق إلى تعيينه، أو عنوان يعود مرارًا. يسجّلون الدخول برمز، مثل الجميع.`)
};

const ms_admin_create_account_sub = /** @type {(inputs: Admin_Create_Account_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untuk orang yang perlu wujud sebelum boleh log masuk — jurulatih yang perlu dilantik oleh pasukan, atau alamat yang asyik muncul semula. Mereka log masuk dengan kod, seperti orang lain.`)
};

const bn_admin_create_account_sub = /** @type {(inputs: Admin_Create_Account_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`যাঁকে সাইন ইন করার আগেই থাকতে হবে তাঁর জন্য — এমন কোচ যাঁকে কোনও দলের নিয়োগ করা দরকার, কিংবা যে ঠিকানা বারবার ফিরে আসে। সবার মতোই তাঁরা কোড দিয়ে সাইন ইন করেন।`)
};

const zh_tw2_admin_create_account_sub = /** @type {(inputs: Admin_Create_Account_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`給那些必須先存在、之後才能登入的人——例如球隊需要指派的教練，或一再出現的電子郵件位址。他們和其他人一樣用驗證碼登入。`)
};

const zh_hk2_admin_create_account_sub = /** @type {(inputs: Admin_Create_Account_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`給那些必須先存在、之後才能登入的人——例如球隊需要指派的教練，或一再出現的電子郵件位址。他們和其他人一樣用驗證碼登入。`)
};

const ur_admin_create_account_sub = /** @type {(inputs: Admin_Create_Account_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اُس شخص کے لیے جسے سائن اِن کرنے سے پہلے موجود ہونا چاہیے — ایسا کوچ جسے کسی ٹیم نے مقرر کرنا ہے، یا وہ پتہ جو بار بار سامنے آتا ہے۔ وہ بھی سب کی طرح کوڈ سے سائن اِن کرتے ہیں۔`)
};

const fa_admin_create_account_sub = /** @type {(inputs: Admin_Create_Account_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`برای کسی که باید پیش از ورود وجود داشته باشد — مربی‌ای که تیمی باید او را معرفی کند، یا نشانی‌ای که مدام بازمی‌گردد. آن‌ها هم مثل بقیه با کد وارد می‌شوند.`)
};

const sw_admin_create_account_sub = /** @type {(inputs: Admin_Create_Account_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kwa mtu anayepaswa kuwepo kabla ya kuweza kuingia — kocha ambaye timu inahitaji kumteua, au anwani inayorudi mara kwa mara. Wanaingia kwa msimbo, kama kila mtu.`)
};

const nl_admin_create_account_sub = /** @type {(inputs: Admin_Create_Account_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voor wie moet bestaan voordat hij kan inloggen — een coach die een team moet aanwijzen, of een adres dat steeds terugkomt. Ze loggen in met een code, net als iedereen.`)
};

/**
* | output |
* | --- |
* | "For somebody who needs to exist before they can sign in — a coach a team must name, or an address that keeps bouncing. They sign in with a code like everybod..." |
*
* @param {Admin_Create_Account_SubInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const admin_create_account_sub = /** @type {((inputs?: Admin_Create_Account_SubInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Create_Account_SubInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_admin_create_account_sub(inputs)
	if (locale === "ja") return ja_admin_create_account_sub(inputs)
	if (locale === "zh") return zh_admin_create_account_sub(inputs)
	if (locale === "es") return es_admin_create_account_sub(inputs)
	if (locale === "pt") return pt_admin_create_account_sub(inputs)
	if (locale === "id") return id_admin_create_account_sub(inputs)
	if (locale === "fr") return fr_admin_create_account_sub(inputs)
	if (locale === "tl") return tl_admin_create_account_sub(inputs)
	if (locale === "vi") return vi_admin_create_account_sub(inputs)
	if (locale === "ko") return ko_admin_create_account_sub(inputs)
	if (locale === "de") return de_admin_create_account_sub(inputs)
	if (locale === "ru") return ru_admin_create_account_sub(inputs)
	if (locale === "tr") return tr_admin_create_account_sub(inputs)
	if (locale === "it") return it_admin_create_account_sub(inputs)
	if (locale === "pl") return pl_admin_create_account_sub(inputs)
	if (locale === "uk") return uk_admin_create_account_sub(inputs)
	if (locale === "hi") return hi_admin_create_account_sub(inputs)
	if (locale === "ar") return ar_admin_create_account_sub(inputs)
	if (locale === "ms") return ms_admin_create_account_sub(inputs)
	if (locale === "bn") return bn_admin_create_account_sub(inputs)
	if (locale === "zh-TW") return zh_tw2_admin_create_account_sub(inputs)
	if (locale === "zh-HK") return zh_hk2_admin_create_account_sub(inputs)
	if (locale === "ur") return ur_admin_create_account_sub(inputs)
	if (locale === "fa") return fa_admin_create_account_sub(inputs)
	if (locale === "sw") return sw_admin_create_account_sub(inputs)
	if (locale === "nl") return nl_admin_create_account_sub(inputs)
	return en_admin_create_account_sub(inputs)
});